const ReportPLB = {
  CashIn: "cashin",
  BuyFuel: "buy-fuel",
  Redemption: "redemption",
  RedemptionItem: "redemption-item",
  FleetAccount: "fleet-account",
  FleetPrices: "fleet-prices",
  PriceMovement: "price-movement",
  PricingChanges: "pricing-changes",
  StationAccount: "station-account",
  StationNegotiatedDiscount: "station-negotiated-discount",
  FuelCard: "fuel-card",
  Payment: "payment",
  MerchantPayment: "merchant-payment",
  VIPRedemptionHistory: "vip-redemption-history",
};

const ReportPLC = {
  CashIn: "cashin",
  BuyFuel: "buy-fuel",
  Redemption: "redemption",
  RedemptionItem: "redemption-item",
  CustomerList: "customer-list",
  Payment: "payment",
  VoucherCampaign: "voucher-campaign",
  DiscountCampaign: "discount-campaign",
  OutrightDiscountCampaign: "outright-discount-campaign",
  VoucherClaim: "voucher-claim",
  RfidTopup: "rfid-topup",
  PriceBuildup: "price-buildup",
  KYCSubmission: "kyc-submission",
  NewCustomerVoucher: "new-customer-voucher",
  LubeservOnSite: "lubeserv-on-site",
  LubeservOnWheels: "lubeserv-on-wheels",
  MerchantPayment: "merchant-payment",
};

const ReportLOCQ = {
  Settlements: "settlements",
};

const ReportType = {
  CashIn: "cashin",
  BuyFuel: "buy-fuel",
  Redemption: "redemption",
  FleetAccount: "fleet-account",
  FleetPrices: "fleet-prices",
  Settlements: "settlements",
  RedemptionItem: "redemption-item",
  PricingHistory: "pricing-history",
  FuelCode: "fuel-code",
  FuelCodes: "fuel-codes",
  Mops: "mops",
  VoucherClaim: "voucher-claim",
  NewCustomerVoucher: "new-customer-voucher",
  PriceBuildup: "price-buildup",
  UniqueVoucher: "unique-voucher",
  PriceMovement: "price-movement",
  PricingChanges: "pricing-changes",
  StationAccount: "station-account",
  CustomerList: "customer-list",
  VoucherCampaign: "voucher-campaign",
  DiscountCampaign: "discount-campaign",
  RfidTopup: "rfid-topup",
  Payment: "payment",
  MerchantPayment: "merchant-payment",
  KYCSubmission: "kyc-submission",
  SupplierWPP: "supplier-wpp",
  LubeservBookings: "lubeserv-bookings",
  StationNegotiatedDiscount: "station-negotiated-discount",
  LubeservOnSite: "lubeserv-on-site",
  LubeservOnWheels: "lubeserv-on-wheels",
  FuelCard: "fuel-card",
  LOCQPayDiscountCampaign: "outright-discount-campaign",
  VIPRedemptionHistory: "vip-redemption-history",
};

/** Report Types
  RedemptionItem: "redemption-item",
  PricingHistory: "pricing-history",
  FuelCode: "fuel-code",
  FuelCodes: "fuel-codes",
  Mops: "mops",
  VoucherClaim: "voucher-claim",
  NewCustomerVoucher: "new-customer-voucher",
  PriceBuildup: "price-buildup",
  StationAccount: "station-account",
  CustomerList: "customer-list",
  VoucherCampaign: "voucher-campaign",
  DiscountCampaign: "discount-campaign",
  RfidTopup: "rfid-topup",
 */

export { ReportLOCQ, ReportPLB, ReportPLC, ReportType };
